// Kiddleton sepet: Horizon'un kendi sepet olayıyla çalışan ekle/kaldır (çekmece yeniden çizilir),
// paket bloğundaki "Sepete Ekle", çekmecedeki panduf satırı, hediye paketi + not, kargo kesim şeridi.
// Horizon product-form.js › #processBatchAddToCart ile aynı akış. layout/theme.liquid'den her sayfada yüklenir.
import { CartLinesUpdateEvent, CartErrorEvent, StandardEvents } from '@shopify/events';

const kok = () => (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
const bolumler = () => {
  const ids = [];
  document.querySelectorAll('cart-items-component').forEach((el) => { if (el.dataset.sectionId) ids.push(el.dataset.sectionId); });
  return ids.join(',');
};

// yol: 'cart/add.js' | 'cart/change.js'; govde: istek gövdesi (sections eklenir)
function sepetIstek(kaynak, yol, govde, satirlar, eylem, kaynakId) {
  const ertelenen = CartLinesUpdateEvent.createPromise();
  kaynak.dispatchEvent(new CartLinesUpdateEvent({ action: eylem, context: 'product', lines: satirlar, promise: ertelenen.promise }));
  return fetch(kok() + yol, {
    method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(Object.assign({}, govde, { sections: bolumler() })),
  }).then((r) => r.json()).then(async (yanit) => {
    const sepet = await fetch(kok() + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    const hata = !!yanit.status;
    if (hata) kaynak.dispatchEvent(new CartErrorEvent({ error: yanit.message || 'Cart update failed', code: 'INVALID', detail: { description: yanit.description } }));
    ertelenen.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(sepet),
      detail: { didError: hata, items: sepet.items, source: 'product-form-component', sourceId: kaynakId || 'kdl-sepet', itemCount: sepet.item_count, sections: yanit.sections },
    });
    if (hata) throw new Error(yanit.description || yanit.message);
    return sepet;
  }).catch((e) => { ertelenen.reject(e); throw e; });
}

const cekmeceyiAc = () => requestAnimationFrame(() => {
  const c = document.getElementById('cart-drawer');
  if (c && typeof c.open === 'function' && !c.isOpen) c.open();
});

// Paket bloğu (kdl-satin-al.js) buradan çağırır
window.kdlSepeteEkle = function (kaynak, items) {
  // Shopify sepeti son ekleneni üstte gösterir: ters sırayla ekle ki 1. battaniye + pandufu en üstte görünsün
  items = items.slice().reverse();
  return sepetIstek(kaynak, 'cart/add.js',
    { items: items.map((x) => ({ id: Number(x.id), quantity: x.quantity })) },
    items.map((x) => ({ merchandiseId: String(x.id), quantity: x.quantity })), 'add'
  ).then((s) => { cekmeceyiAc(); return s; });
};

// Çekmece: panduf ekle, hediye paketi aç/kapat
document.addEventListener('click', (e) => {
  const b = e.target.closest('[data-kdl-ekle]');
  if (!b) return;
  b.disabled = true;
  const id = b.getAttribute('data-kdl-ekle');
  sepetIstek(b, 'cart/add.js', { items: [{ id: Number(id), quantity: 1 }] }, [{ merchandiseId: id, quantity: 1 }], 'add')
    .catch(() => { b.disabled = false; });
});
document.addEventListener('change', (e) => {
  const k = e.target.closest('[data-kdl-hediye]');
  if (!k) return;
  k.disabled = true;
  if (k.checked) {
    const id = k.getAttribute('data-kdl-hediye');
    sepetIstek(k, 'cart/add.js', { items: [{ id: Number(id), quantity: 1 }] }, [{ merchandiseId: id, quantity: 1 }], 'add')
      .catch(() => { k.checked = false; k.disabled = false; });
  } else {
    // Not yazılınca satır anahtarı değişir: güncel anahtarı sepetten oku
    fetch(kok() + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).then((sepet) => {
      const s = sepet.items.find((x) => x.handle === 'hediye-paketi');
      if (!s) { k.disabled = false; return; }
      return sepetIstek(k, 'cart/change.js', { id: s.key, quantity: 0 }, [{ merchandiseId: s.key, quantity: 0 }], 'update');
    }).catch(() => { k.checked = true; k.disabled = false; });
  }
});
// Hediye notu: hediye paketi satırının "Not" özelliği (kapıda ödeme formuyla aynı yer; siparişte satırın altında görünür)
let notZaman;
document.addEventListener('input', (e) => {
  const t = e.target.closest('[data-kdl-not]');
  if (!t) return;
  clearTimeout(notZaman);
  notZaman = setTimeout(async () => {
    try {
      const sepet = await fetch(kok() + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const s = sepet.items.find((x) => x.handle === 'hediye-paketi');
      if (!s) return;
      await fetch(kok() + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: s.key, quantity: s.quantity, properties: Object.assign({}, s.properties, { Not: t.value }) }) });
    } catch (e) { /* sessiz */ }
  }, 500);
});

// Kargo kesim şeridi (İstanbul saati)
const AY = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
const GUN = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'];
function kesimDoldur(el) {
  const kesim = Number(el.dataset.kesim) || 17;
  const cumartesi = el.dataset.cumartesi === 'true';
  const tMin = Number(el.dataset.min) || 1, tMax = Number(el.dataset.max) || 2;
  const tatil = (el.dataset.tatil || '').split(',').map((x) => x.trim()).filter(Boolean);
  const p = {};
  new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Istanbul', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false })
    .formatToParts(new Date()).forEach((x) => { p[x.type] = x.value; });
  const bugun = new Date(Date.UTC(+p.year, +p.month - 1, +p.day));
  const saat = +p.hour % 24, dk = +p.minute;
  const anahtar = (d) => d.toISOString().slice(0, 10);
  const ekle = (d, n) => { const x = new Date(d); x.setUTCDate(x.getUTCDate() + n); return x; };
  const kargoGunu = (d) => { const g = d.getUTCDay(); return g !== 0 && (g !== 6 || cumartesi) && !tatil.includes(anahtar(d)); };
  const isGunu = (d) => { const g = d.getUTCDay(); return g !== 0 && g !== 6 && !tatil.includes(anahtar(d)); };
  const bugunCikar = kargoGunu(bugun) && saat < kesim;
  let cikis = bugun;
  if (!bugunCikar) { cikis = ekle(bugun, 1); while (!kargoGunu(cikis)) cikis = ekle(cikis, 1); }
  const ileri = (n) => { let d = cikis, k = 0; while (k < n) { d = ekle(d, 1); if (isGunu(d)) k++; } return d; };
  const a = ileri(tMin), b = ileri(tMax);
  const tarih = a.getUTCMonth() === b.getUTCMonth()
    ? (a.getUTCDate() === b.getUTCDate() ? a.getUTCDate() : a.getUTCDate() + '-' + b.getUTCDate()) + ' ' + AY[b.getUTCMonth()]
    : a.getUTCDate() + ' ' + AY[a.getUTCMonth()] + ' - ' + b.getUTCDate() + ' ' + AY[b.getUTCMonth()];
  let baslik;
  if (bugunCikar) {
    const kalan = kesim * 60 - (saat * 60 + dk);
    const s = Math.floor(kalan / 60), m = kalan % 60;
    baslik = 'Bugün kargoda: ' + String(kesim).padStart(2, '0') + '.00’ye ' + (s ? s + ' sa ' : '') + m + ' dk';
  } else {
    const fark = Math.round((cikis - bugun) / 86400000);
    baslik = (fark === 1 ? 'Yarın' : GUN[cikis.getUTCDay()]) + ' ilk kargoyla çıkıyor';
  }
  const bEl = el.querySelector('[data-kdl-kesim-baslik]'), aEl = el.querySelector('[data-kdl-kesim-alt]');
  if (bEl && bEl.textContent !== baslik) bEl.textContent = baslik;
  const alt = 'Tahmini teslim ' + tarih;
  if (aEl && aEl.textContent !== alt) aEl.textContent = alt;
}
// Judge.me'de çevrilmemiş kalan görünür metinler (panelden dil ayarı açılmadığı için tema tarafında)
const JDGM_CEVIRI = { 'Sort by': 'Sırala', 'Thumbnail Navigation': 'Küçük görseller' };
function jdgmCevir() {
  document.querySelectorAll('.jdgm-widget').forEach((w) => {
    const yuru = document.createTreeWalker(w, NodeFilter.SHOW_TEXT);
    let n;
    while ((n = yuru.nextNode())) {
      const t = n.textContent.trim();
      if (JDGM_CEVIRI[t]) n.textContent = n.textContent.replace(t, JDGM_CEVIRI[t]);
    }
  });
}
const hepsiniDoldur = () => { try { document.querySelectorAll('[data-kdl-kesim]').forEach(kesimDoldur); jdgmCevir(); } catch (e) {} };
hepsiniDoldur();
setInterval(hepsiniDoldur, 30000);
// Çekmece yeniden çizilince (morph) şeridi tekrar doldur
let bekleyen = false;
new MutationObserver(() => {
  if (bekleyen) return; bekleyen = true;
  requestAnimationFrame(() => { bekleyen = false; hepsiniDoldur(); });
}).observe(document.documentElement, { childList: true, subtree: true });

// Kardeş kartı (çekmece): seçilen karakter + beden → 2. battaniye; hediye panduflar senkronla gelir
document.addEventListener('click', (e) => {
  const b = e.target.closest('[data-kdl-kardes]');
  if (!b) return;
  const kutu = b.closest('[data-kdl-kardes-kutu]');
  const k = kutu.querySelector('input[name="kdl-kardes-k"]:checked');
  const bd = kutu.querySelector('input[name="kdl-kardes-b"]:checked');
  let harita = {};
  try { harita = JSON.parse(kutu.querySelector('[data-kdl-kardes-veri]').textContent); } catch (x) {}
  const id = k && bd ? harita[k.value + '|' + bd.value] : null;
  if (!id) return;
  b.disabled = true;
  sepetIstek(b, 'cart/add.js', { items: [{ id: Number(id), quantity: 1 }] }, [{ merchandiseId: String(id), quantity: 1 }], 'add')
    .catch(() => { b.disabled = false; });
});

// Sepet senkronu: kurallar snippets/kdl-sepet-kurallar.liquid (window.kdlSepetDuzelt), kapıda ödeme formuyla ortak.
// Battaniye yoksa panduf/hediyeler kalkar; 2+ battaniyede her battaniyeye kendi renginde hediye panduf; hediye paketi en fazla 1.
let hediyeUrun;
async function hediyeAl() {
  if (hediyeUrun !== undefined) return hediyeUrun;
  try {
    const r = await fetch(kok() + 'products/panduf-hediye.js', { headers: { Accept: 'application/json' } });
    hediyeUrun = r.ok ? await r.json() : null;
  } catch (e) { hediyeUrun = null; }
  return hediyeUrun;
}
const ILGILI = ['giyilebilir-battaniye', 'panduf-corap', 'panduf-hediye', 'hediye-paketi'];
let senkronda = false;
async function senkron() {
  if (senkronda || typeof window.kdlSepetDuzelt !== 'function') return;
  senkronda = true;
  try {
    const sepet = await fetch(kok() + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    if (!sepet.items.some((x) => ILGILI.includes(x.handle))) return; // gereksiz istek yok
    const h = await hediyeAl();
    const d = window.kdlSepetDuzelt(sepet, h && h.available ? h.variants : []);
    const anahtarlar = Object.keys(d.degis);
    if (anahtarlar.length) {
      await sepetIstek(document.body, 'cart/update.js', { updates: d.degis },
        anahtarlar.map((k) => ({ merchandiseId: k, quantity: d.degis[k] })), 'update', 'kdl-senkron');
    }
    if (d.ekle.length) {
      await sepetIstek(document.body, 'cart/add.js', { items: d.ekle },
        d.ekle.map((x) => ({ merchandiseId: String(x.id), quantity: x.quantity })), 'add', 'kdl-senkron');
    }
  } catch (e) {
    // sessiz: senkron başarısızsa sepet olduğu gibi kalır
  } finally {
    senkronda = false;
  }
}
document.addEventListener(StandardEvents.cartLinesUpdate, (e) => {
  if (e.detail && e.detail.sourceId === 'kdl-senkron') return;
  if (e.promise) e.promise.then((sonuc) => {
    if (sonuc && sonuc.detail && sonuc.detail.sourceId === 'kdl-senkron') return;
    setTimeout(senkron, 60);
  }).catch(() => {});
});
senkron();
